export default __webpack_public_path__ + "static/media/phil_coaching_hat.b9fdacff.jpg";